import {
  TCreatePreOrderDrugInfo,
  TQueryRecommendGoods,
  TQueryRecommendShopGoods
} from '@/schemas/med';
import { IAddedDrugVo } from '@/schemas/prescription';

interface IState {
  recommendMeds: IAddedDrugVo[]; // 医生商品建议单已添加药品
  recommendMedIds: string[]; // 医生商品建议单已添加药品ID列表
  recommendMedIdsCurrentSearch: string[]; // 当前搜索页医生商品建议单已添加药品ID列表

  createPreOrderDrugInfoList: TCreatePreOrderDrugInfo[]; // 用户购物车选择药品列表
  lastQueryRecommendGoods: TQueryRecommendGoods; // 用户购物车商品建议单详情
  lastMedCountMap: Record<string, number>; // 用户购物车商品数量
  lastMedShopList: TQueryRecommendShopGoods[]; // 用户购物车商品列表

  isBackFromMedAddrAdd: boolean; // 标记是否从编辑页返回
}

const initState: IState = {
  recommendMeds: [] as IAddedDrugVo[],
  recommendMedIds: [] as string[],
  recommendMedIdsCurrentSearch: [] as string[],
  createPreOrderDrugInfoList: [] as TCreatePreOrderDrugInfo[],
  lastQueryRecommendGoods: {} as TQueryRecommendGoods,
  lastMedCountMap: {} as Record<string, number>,
  lastMedShopList: [] as TQueryRecommendShopGoods[],
  isBackFromMedAddrAdd: false
};

const prescription = {
  state: initState,

  reducers: {
    updateState<K extends keyof IState>(
      state: IState,
      payload: {
        [key: string]: IState[K];
      }
    ): IState {
      return {
        ...state,
        ...payload
      };
    }
  }
};

export default prescription;
